import PageWrapper from "@/pages/PageWrapper";
import Services from "@/sections/Services";
import BuildingExperience from "@/sections/BuildingExperience";
import Process from "@/sections/Process";
import useSEO from "@/lib/useSEO";

export default function ServicesPage() {
    useSEO({
        title: "Services — Architecture, Interiors, Construction, Planning & Renovation | ate.teen studio",
        description:
            "End-to-end services from ate.teen studio: architecture, interior design, construction, planning and renovation. Kerala-based, site-first, delivered from concept to key handover.",
        path: "/services",
    });
    return (
        <PageWrapper className="pt-24">
            <h1 className="sr-only">
                ate.teen studio services — architecture, interior design, construction, planning and renovation
            </h1>
            <Services />
            <BuildingExperience />
            <Process />
        </PageWrapper>
    );
}
